/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "../../../components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "../../../examples/Cards/InfoCards/DefaultInfoCard";

function Information() {
  return (
    <MKBox component="section" my={0}>
      <Grid container spacing={3} alignItems="stretch">
        <Grid item xs={12} md={6}>
          <DefaultInfoCard
            icon="content_copy"
            title="aelchim"
            description="Updates on the stuff I am doing and building."
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <DefaultInfoCard
            icon="flip_to_front"
            title="Volta Software"
            description="Information on all the products made by VoltaSoftware (my company)"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <DefaultInfoCard
            icon="price_change"
            title="WednesdayCoin"
            description="Updates and information on all the stuff I am doing with WednesdayCoin!"
          />
        </Grid>
      </Grid>
    </MKBox>
  );
}

export default Information;
